import { of } from "rxjs";
import { LoginTypes } from "@nxplatform/platform-entities";
import { preloadApi } from "@nxplatform/store-utils/misc/preload-decorator";
import { ClientSwitcher } from "@service/api-client/client-switcher";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = __getOwnPropDesc(target, key);
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = decorator(target, key, result) || result;
  if (result) __defProp(target, key, result);
  return result;
};
var RegistrationTypes = /* @__PURE__ */ ((RegistrationTypes2) => {
  RegistrationTypes2["base"] = "base";
  RegistrationTypes2["kenya"] = "kenya";
  RegistrationTypes2["senegal"] = "senegal";
  RegistrationTypes2["netherlands"] = "netherlands";
  RegistrationTypes2["latvia"] = "latvia";
  RegistrationTypes2["spain"] = "spain";
  RegistrationTypes2["estonia"] = "estonia";
  RegistrationTypes2["ontario"] = "ontario";
  RegistrationTypes2["zambia"] = "zambia";
  RegistrationTypes2["australia"] = "australia";
  RegistrationTypes2["portugal"] = "portugal";
  RegistrationTypes2["ghana"] = "ghana";
  RegistrationTypes2["oneStep"] = "one-step";
  RegistrationTypes2["custom"] = "custom";
  return RegistrationTypes2;
})(RegistrationTypes || {});
const baseLoginTypeByRegistrationType = {
  [
    "base"
    /* base */
  ]: LoginTypes.email,
  [
    "kenya"
    /* kenya */
  ]: LoginTypes.phone,
  [
    "senegal"
    /* senegal */
  ]: LoginTypes.phone,
  [
    "netherlands"
    /* netherlands */
  ]: LoginTypes.email,
  [
    "latvia"
    /* latvia */
  ]: LoginTypes.email,
  [
    "estonia"
    /* estonia */
  ]: LoginTypes.email,
  [
    "zambia"
    /* zambia */
  ]: LoginTypes.phone,
  [
    "australia"
    /* australia */
  ]: LoginTypes.email
};
class PlatformSettingsClient extends ClientSwitcher {
  constructor() {
    super(...arguments);
    this.setupEndPoint = "api/v2/configurations";
    this.regConfigurations = "api/v2/registration-configurations";
  }
  getSetup() {
    return this.get(this.setupEndPoint);
  }
  getSetupBaseSetup() {
    if (window.applicationSetup) {
      return of(window.applicationSetup);
    }
    return this.getSetup();
  }
  registrationConfigurations() {
    return this.get(this.regConfigurations, { desktop: 1 });
  }
}
__decorateClass([
  preloadApi()
], PlatformSettingsClient.prototype, "getSetup");
var LimitsThemes = /* @__PURE__ */ ((LimitsThemes2) => {
  LimitsThemes2["twentyBet"] = "twentyBet";
  LimitsThemes2["twentyTwoBet"] = "twentyTwoBet";
  LimitsThemes2["nationalCasino"] = "nationalCasino";
  LimitsThemes2["bizzoCasino"] = "bizzoCasino";
  LimitsThemes2["hellspinCasino"] = "hellspinCasino";
  return LimitsThemes2;
})(LimitsThemes || {});
export {
  LimitsThemes,
  PlatformSettingsClient,
  RegistrationTypes,
  baseLoginTypeByRegistrationType
};
